var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#141414"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5251 53.5251C20.1583 54.892 20.1583 57.108 21.5251 58.4749C22.892 59.8417 25.108 59.8417 26.4749 58.4749L24 56L21.5251 53.5251ZM59.5 24C59.5 22.067 57.933 20.5 56 20.5H24.5C22.567 20.5 21 22.067 21 24C21 25.933 22.567 27.5 24.5 27.5H52.5V55.5C52.5 57.433 54.067 59 56 59C57.933 59 59.5 57.433 59.5 55.5V24ZM24 56L26.4749 58.4749L58.4749 26.4749L56 24L53.5251 21.5251L21.5251 53.5251L24 56Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8e5458f256ad393c7fc0c1167ed4859b.svg";
export { ForwardRef as ReactComponent };